<template>
  <div class="shift-card">
    <ion-grid>
      <ion-row>
        <ion-col size align-self-center class="ion-text-center">
          <ion-text
            class="shift-card-icon"
            v-bind:color="shift.verification_stage | verificationColor"
          >
            <font-awesome-icon
              v-bind:icon="shift.type | shiftTypeIcon"
            ></font-awesome-icon>
          </ion-text>
        </ion-col>

        <ion-col size="9" align-self-center>
          <h5 class="h-f-b">
            {{ shiftStartFormatted }} -
            {{ shiftEndFormatted }}
          </h5>

          <p>{{ shift.verification_stage | shiftTypeText }}</p>
        </ion-col>

        <ion-col size="12">
          <ion-button v-if="!isCancelled(shift)" @click="toggleBreakdown()" expand="full" color="primary">
            <font-awesome-icon slot="start" icon="eye"></font-awesome-icon>
            <span class="m-l-m">
              <span v-if="showBreakdown === false">View</span>
              <span v-if="showBreakdown === true">Hide</span>
              Breakdown
            </span>
          </ion-button>
        </ion-col>
      </ion-row>
    </ion-grid>

    <div class="shift-card-breakdown ion-padding-bottom" v-if="showBreakdown">
      <ion-list lines="full">
        <ion-item v-if="shift.type == 'TV_SHIFT'">
          <ion-label>Hourly Rate</ion-label>
          <div slot="end">£{{ shift.hourly_rate.toFixed(2) }}</div>
        </ion-item>

        <ion-item v-if="shift.type == 'CAM_SHIFT'">
          <ion-label>Minimum payout</ion-label>
          <div slot="end">£{{ shift.minimum_payout.toFixed(2) }}</div>
        </ion-item>

        <ion-item v-if="shift.type == 'CAM_SHIFT'">
          <ion-label>Payout Bonus</ion-label>
          <div slot="end">£{{ shift.payout_bonus.toFixed(2) }}</div>
        </ion-item>

        <ion-item>
          <ion-label>Total Earnings</ion-label>
          <div slot="end">£{{ shift.total_earnings.toFixed(2) }}</div>
        </ion-item>
      </ion-list>

      <div v-if="shift.earnings_breakdown" class="shift-card-earnings">
        <div
          class="ion-padding ion-text-center shift-card-earnings-header h-f-b"
        >
          <ion-text class="h-f-b">Earnings Breakdown</ion-text>
        </div>
        <!-- /.shift-card-earnings-header -->

        <ion-list class="ion-no-padding" lines="full">
          <ion-item
            v-for="(value, name, index) in shift.earnings_breakdown"
            v-bind:key="index"
          >
            <ion-label>{{
              products[name] ? products[name] : "Cams"
            }}</ion-label>
            <div slot="end">£{{ value.toFixed(2) }}</div>
          </ion-item>
        </ion-list>
      </div>
      <!-- /.shift-card-earnings -->
    </div>
    <!-- /.shift-card-breakdown -->
  </div>
  <!-- /.shift-card -->
</template>

<script>
import moment from "moment";

export default {
  name: "shift-card",
  props: {
    shift: { type: Object },
    products: { type: Object },
  },
  data() {
    return {
      showBreakdown: false,
      shiftDateFormat: "ddd, MMM Do [at] h:mm a",
    };
  },
  methods: {
    toggleBreakdown() {
      this.showBreakdown = !this.showBreakdown;
    },
    isCancelled(value) {
      return value.verification_stage === 'CANCELLED' ? true : false;
    }
  },
  computed: {
    shiftStartFormatted() {
      return moment
        .utc(this.shift.start_time)
        .local()
        .format(this.shiftDateFormat);
    },
    shiftEndFormatted() {
      return moment
        .utc(this.shift.end_time)
        .local()
        .format(this.shiftDateFormat);
    },
  },
  filters: {
    formatTime(value, format) {
      if (!value) {
        return;
      }
      return moment(value)
        .local()
        .format(format);
    },

    shiftTypeIcon(value) {
      if (!value) {
        return;
      }

      let type = "tv";

      if (value === "CAM_SHIFT") {
        type = "video";
      }
      return type;
    },

    shiftTypeText(value) {
      if (!value) {
        return;
      }

      switch (value) {
        case "VERIFIED":
          return "Verified";
        case "WAITING_FOR_CALCULATION":
          return "Waiting for all payment confirmation - this can take up to 24 hours";
        case "WAITING_FOR_VERIFICATION":
          return "Wating for a member of staff to verify your shift payment";
        case "CANCELLED":
          return "This shift has been cancelled";
        default:
          return "Upcoming Shift";
      }
    },

    verificationColor(value) {
      if (!value) {
        return;
      }

      switch (value) {
        case "VERIFIED":
          return "success";
        case "WAITING_FOR_CALCULATION":
          return "tertiary";
        case "WAITING_FOR_VERIFICATION":
          return "warning";
        case "CANCELLED":
          return "dark";
        default:
          return "secondary";
      }
    }
  },
};
</script>

<style scoped>
.shift-card-icon {
  font-size: 2rem;
}

.shift-card-breakdown {
  background: var(--ion-item-background, var(--ion-background-color, #fff));
}

.shift-card-earnings-header {
  background: var(--ion-color-dark);
}

.shift-card-breakdown ion-item {
  font-size: 14px;
}
</style>
